import { MenuItem } from "@/stores";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

interface TabProps {
  label: string;
  notificationCount?: number;
  active: boolean;
  onClick: () => void;
}

const Tab: FC<TabProps> = ({ label, notificationCount, active, onClick }) => {
  return (
    <button
      className={`flex items-center space-x-2 px-1 py-2 text-sm font-medium  ${
        active ? "border-b-2  border-black" : "text-gray-500"
      }`}
      onClick={onClick}
    >
      <span>{label}</span>
      {notificationCount && notificationCount > 0 && (
        <span className="inline-block bg-red-500 text-white rounded-full text-xs px-2 py-1">
          {notificationCount}
        </span>
      )}
    </button>
  );
};

interface TabsProps {
  tabs: MenuItem[];
  activeTab: number;
  setActiveTab: (index: number) => void;
}

const Tabs: FC<TabsProps> = ({ tabs, activeTab, setActiveTab }) => {
    const navigate = useNavigate();

    const handleTabClick = (tab: MenuItem, tabIndex:number) =>{
        navigate(tab.path);
        setActiveTab(tabIndex)
    }

  return (
    <div className="flex space-x-6 px-4 py-1">
      {tabs.map((tab, index) => (
        <Tab
          key={index}
          label={tab.name}
          notificationCount={tab.notificationCount}
          active={activeTab === index}
          onClick={() =>handleTabClick(tab, index) }
        />
      ))}
    </div>
  );
};

export default Tabs;
